import { Pressable, Text } from 'react-native';
import { onboardingStyles as s } from '../OnboardingFlow.styles';
import { ONBOARDING_TEST_IDS } from '../OnboardingFlow.constants';

/** Shared back chevron for the onboarding steps. */
export function BackButton({ onPress }: { onPress: () => void }) {
  return (
    <Pressable
      onPress={onPress}
      testID={ONBOARDING_TEST_IDS.BACK}
      accessibilityRole="button"
      accessibilityLabel="Back"
      style={({ pressed }) => [s.backButton, pressed && s.pressed]}
    >
      <Text style={s.backGlyph}>‹</Text>
    </Pressable>
  );
}
